
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConfirmDiscardChanges',
  setup() {
    return {};
  }
});
